import { StreamingPlayerUIPageV2 } from '@heardis/stream-contracts';
import { SettingsContextAnalyticsStatus, useSettingsContext } from '../../../contexts/SettingsContext';
import { classNames } from '../../../utils/styles';
import { BackgroundImage } from '../../Image';
import CookieContainer from '../../InfoContainer/CookieContainer';
import LoginContainer from '../../InfoContainer/LoginContainer';
import Footer from '../Footer/Footer';
import Header from '../Header/Header';
import classes from './LoginScreen.module.css';

type LoginScreenProps = {
  page: StreamingPlayerUIPageV2;
};

function LoginScreen({ page }: LoginScreenProps) {
  const { analytics, setAnalytics } = useSettingsContext();
  const { sections, typography, background, logo, title, features } = page;
  const { fontFamily, fontSize, fontWeight, color } = typography;
  const { header, footer, secondary, primary } = sections;

  return (
    <div className={classes.pageWrapper} style={{ fontFamily, fontSize, fontWeight, color, backgroundColor: background.color }}>
      {analytics === SettingsContextAnalyticsStatus.NOT_SET && (
      <div className={classes.cookieOverlay}>
        <div className={classNames(classes.cookieContainerWrapper, classes.active)}>
          <CookieContainer
            backgroundColor={secondary.background.color}
            typography={secondary.typography}
          />
        </div>
      </div>
      )}
      <Header
        backgroundColor={header.background.color}
        backgroundImage={header.background.image}
        typography={header.typography}
        logo={logo}
        title={title}
        descriptionEnabled={false}
        showDescription={() => {}}
      />
      <main
        className={classes.main}
        style={{
          backgroundColor: primary.background.color,
          fontSize: primary.typography.fontSize,
          fontFamily: primary.typography.fontFamily,
          fontWeight: primary.typography.fontWeight,
          color: primary.typography.color,
        }}
      >
        <div className={classes.infoContainerWrapper}>
          <LoginContainer backgroundColor={secondary.background.color} typography={secondary.typography} />
        </div>
        {primary.background.image.url && (
        <BackgroundImage
          url={primary.background.image.url}
          alt={primary.background.image.alt}
          blur={primary.background.image.blur}
          position={primary.background.image.position}
          fit={primary.background.image.fit}
          zIndex={-10}
        />
        )}
      </main>
      <Footer
        typography={footer.typography}
        backgroundColor={footer.background.color}
        backgroundImage={footer.background.image}
        analyticsEnabled={features.analytics}
        showCookieBanner={() => setAnalytics(SettingsContextAnalyticsStatus.NOT_SET)}
      />
      {background.image.url && (
      <BackgroundImage
        url={background.image.url}
        alt={background.image.alt}
        blur={background.image.blur}
        position={background.image.position}
        fit={background.image.fit}
        zIndex={-20}
      />
      )}
    </div>
  );
}

export default LoginScreen;
